import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getBranchCode, getCompanyCode, getLicenseeCode } from "./GetUserInfo.js";
import { getMainDefinition } from "@apollo/client/utilities";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";

export const initializeClient = async () => {
  const token = await sessionStorage.getItem("tokenf");
  const licenseeCode = await getLicenseeCode();
  const { CompanyCode } = await getCompanyCode();
  const { BranchCode } = await getBranchCode();

  // Check if all codes are present
  const isAllCodesAvailable = licenseeCode && CompanyCode && BranchCode;

  const uri = isAllCodesAvailable
    ? `${process.env.REACT_APP_API_URL}/graphql/${licenseeCode}/${CompanyCode}/${BranchCode}`
    : `${process.env.REACT_APP_API_URL}/graphql/`;

  const defaultLink = new HttpLink({
    uri: uri,
    credentials: "include",
  });

  const wsDefaultLink = new GraphQLWsLink(
    createClient({
      url: `${process.env.REACT_APP_WS_API_URL}/graphql/${licenseeCode}/${CompanyCode}/${BranchCode}`,
      credentials: "include",
      connectionParams: {
        authorization: token ? `${token}` : "",
      },
      options: {
        reconnect: true,
      },
    })
  );

  const secondaryLink = new HttpLink({
    uri: `${process.env.REACT_APP_CUSTOMER_SITE_BACKEND}/graphql`,
    credentials: "include",
  });

  const wsLinkSecondary = new GraphQLWsLink(
    createClient({
      url: `${process.env.REACT_APP_WS_CUSTOMER_SITE}/graphql`,
      credentials: "include",
      connectionParams: {
        authorization: token ? `${token}` : "",
      },
      options: {
        reconnect: true,
      },
    })
  );

  // Third link for the new location backend
  const locationLink = new HttpLink({
    uri: `${process.env.REACT_APP_CUSTOMER_SITE_LOCATION_BACKEND}/graphql`,
    credentials: "include",
  });

  const wsLinkLocation = new GraphQLWsLink(
    createClient({
      url: `${process.env.REACT_APP_WS_CUSTOMER_SITE_LOCATION}/graphql`,
      credentials: "include",
      connectionParams: {
        authorization: token ? `${token}` : "",
      },
      options: {
        reconnect: true,
      },
    })
  );
  /* ─ Orion backend ───────────────────────────────────────── */
  const orionLink = new HttpLink({
    uri: `${process.env.REACT_APP_ORION_APP_BACKEND}/graphql/${licenseeCode}/${CompanyCode}/${BranchCode}`,
    credentials: "include",
  });

  const wsLinkOrion = new GraphQLWsLink(
    createClient({
      url: `${process.env.REACT_APP_WS_ORION_APP_BACKEND}/graphql/${licenseeCode}/${CompanyCode}/${BranchCode}`, // remove if you don’t need subscriptions
      credentials: "include",
      connectionParams: { authorization: token ? token : "" },
      options: { reconnect: true },
    })
  );

  const chooseLink = new ApolloLink((operation, forward) => {
    const context = operation.getContext();
    const serverHeader = context?.headers?.["X-GraphQL-Server"];
    const definition = getMainDefinition(operation.query);

    /* —> NEW  Orion routing */
    if (serverHeader === "orion" && definition.operation === "subscription") {
      return wsLinkOrion.request(operation, forward);
    } else if (serverHeader === "orion") {
      return orionLink.request(operation, forward);
    }

    /* existing clauses … */
    if (serverHeader === "secondary" && definition.operation === "subscription") {
      return wsLinkSecondary.request(operation, forward);
    } else if (serverHeader === "secondary") {
      return secondaryLink.request(operation, forward);
    }

    if (serverHeader === "secondary" && definition.operation === "subscription") {
      return wsLinkSecondary.request(operation, forward);
    } else if (serverHeader === "secondary") {
      return secondaryLink.request(operation, forward);
    } else if (serverHeader === "location" && definition.operation === "subscription") {
      return wsLinkLocation.request(operation, forward);
    } else if (serverHeader === "location") {
      return locationLink.request(operation, forward);
    } else if (definition.operation === "subscription") {
      return wsDefaultLink.request(operation, forward);
    }
    return defaultLink.request(operation, forward);
  });

  const authLink = setContext(async (_, { headers }) => {
    const token = await sessionStorage.getItem("tokenf");
    const From_Date = JSON.parse(sessionStorage.getItem("SelectedFromDate"));
    const To_Date = JSON.parse(sessionStorage.getItem("SelectedToDate"));
    const DateData = JSON.parse(sessionStorage.getItem("SelectedFinancialYear"));
    const UserSelectedBranch = JSON.parse(sessionStorage.getItem("UserSelectedBranch"));
    let branchCode = Array.isArray(UserSelectedBranch)
      ? UserSelectedBranch
      : UserSelectedBranch?.BranchCode
      ? UserSelectedBranch?.BranchCode
      : "";
    const path = window.location.pathname;

    return {
      headers: {
        authorization: token ? `${token}` : "",
        requestUrl: path,
        licenseeCode,
        companyCode: CompanyCode,
        branchCode: BranchCode,
        UserSelectedBranch: branchCode,
        usertype: headers?.usertype ? headers?.usertype : "erp",
        FromDate: From_Date,
        ToDate: To_Date,
        FinancialYearFromDate: DateData?.fromDate,
        FinancialYearToDate: DateData?.toDate,
        ...headers,
      },
    };
  });

  const link = authLink.concat(chooseLink);

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
};

export const GetLink = () => {
  let getLink = `${process.env.REACT_APP_API_URL}/graphql`;
  const token = sessionStorage.getItem("tokenf");

  let defaultLink = new HttpLink({
    uri: getLink,
    credentials: "include",
  });

  const secondaryLink = new HttpLink({
    uri: `${process.env.REACT_APP_CUSTOMER_SITE_BACKEND}/graphql`,
    credentials: "include",
  });

  const wsLinkSecondary = new GraphQLWsLink(
    createClient({
      url: `${process.env.REACT_APP_WS_CUSTOMER_SITE}/graphql`,
      connectionParams: {
        authorization: token ? `${token}` : "",
      },
      options: {
        reconnect: true,
      },
    })
  );

  // Third link for the new location backend
  const locationLink = new HttpLink({
    uri: `${process.env.REACT_APP_CUSTOMER_SITE_LOCATION_BACKEND}/graphql`,
    credentials: "include",
  });

  const wsLinkLocation = new GraphQLWsLink(
    createClient({
      url: `${process.env.REACT_APP_WS_CUSTOMER_SITE_LOCATION}/graphql`,
      connectionParams: {
        authorization: token ? `${token}` : "",
      },
      options: {
        reconnect: true,
      },
    })
  );

  const chooseLink = new ApolloLink((operation, forward) => {
    const context = operation.getContext();
    const serverHeader = context?.headers?.["X-GraphQL-Server"];
    const definition = getMainDefinition(operation.query);

    if (serverHeader === "secondary") {
      return secondaryLink.request(operation, forward);
    }
    if (serverHeader === "secondary" && definition.operation === "subscription") {
      return wsLinkSecondary.request(operation, forward);
    }
    if (serverHeader === "location") {
      return locationLink.request(operation, forward);
    }
    if (serverHeader === "location" && definition.operation === "subscription") {
      return wsLinkLocation.request(operation, forward);
    }
    return defaultLink.request(operation, forward);
  });

  const authLink = setContext(async (_, { headers }) => {
    const token = await sessionStorage.getItem("tokenf");
    const From_Date = JSON.parse(sessionStorage.getItem("SelectedFromDate"));
    const To_Date = JSON.parse(sessionStorage.getItem("SelectedToDate"));
    const DateData = JSON.parse(sessionStorage.getItem("SelectedFinancialYear"));
    const path = window.location.pathname;

    return {
      headers: {
        authorization: token ? `${token}` : "",
        requestUrl: path,
        usertype: headers?.usertype ? headers?.usertype : "erp",
        FromDate: From_Date,
        ToDate: To_Date,
        FinancialYearFromDate: DateData?.fromDate,
        FinancialYearToDate: DateData?.toDate,
        ...headers,
      },
    };
  });

  const link = authLink.concat(chooseLink);

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
};
